import { FADED_CELL_CLASSNAME } from '@talos/kyoko';
import type { CellClassRules } from 'ag-grid-community';
import { LegRow, type CareOrderBlotterEntity } from '../types';

export const legRowFadedCellClassRules: CellClassRules<CareOrderBlotterEntity> = {
  [FADED_CELL_CLASSNAME]: params => params.data instanceof LegRow,
};
